import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPause: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"pause"} maskId="square-filled-radius-0-stroke-1-IconPause"><path d="M4 3V21H10V3H4Z" fill="currentColor"/><path d="M14 3V21H20V3H14Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPause;
